export const getItemListNameForAddToWishlist = (
  pageCategory?: string | null,
  pageSubCategory?: string | null,
  pageSubSubCategory?: string | null,
  pageSubSubSubCategory?: string | null,
): string | undefined => {
  const categories = [
    pageCategory,
    pageSubCategory,
    pageSubSubCategory,
    pageSubSubSubCategory,
  ];

  const validCategories = categories.filter(
    (category) => !!category && category !== "undefined",
  );

  const itemListName = validCategories.join("|");
  if (!itemListName) {
    return undefined;
  }

  return itemListName;
};
